import EntityApiServicePopulate from 'utils/EntityApiServicePopulate';
import { IAuditPopulated } from '../interfaces/IAuditPopulated';

class AuditServicePopulate extends EntityApiServicePopulate<IAuditPopulated> {}

export default new AuditServicePopulate('/ms-core/api/audit');
